<template>
  <div
    class="help-complex-item rounded d-flex align-items-center px-3 py-2"
    :class="checked ? 'checked-element--show' : ''"
    :style="`background-color:${color};`"
    @click="() => handleClick(data.value)"
  >
    <div class="check-icon">
      <span class="p-0 m-0">✓</span>
    </div>
    <div class="help-complex-item-text d-flex">
      {{ data.text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: 'grey',
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    handleClick() {
      this.checked = !this.checked;
      this.$emit('onChecked', { checked: this.checked });
    },
  },
};
</script>

<style scoped lang="scss">
.help-complex-item {
  min-height: 70px;
  box-shadow: 0px 2px 8px #00000026;

  .check-icon {
    margin-right: 0;
    width: 0;
    overflow: hidden;

    transition: width 200ms linear, margin-right 200ms linear;
    -webkit-transition: width 200ms linear, margin-right 200ms linear;
    -moz-transition: width 200ms linear, margin-right 200ms linear;
  }

  .help-complex-item-text {
    flex: 1;
  }
}

.checked-element--show,
.help-complex-item:hover {
  background: linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
  color: #ffffff;
  .check-icon {
    margin-right: 9px;
    width: 21px;
  }
}
</style>
